import React from 'react'
import { graphql } from 'gatsby'

import { processContext } from '../contentful'
import { ContactElement } from '../enums'
import WhoWeAre from '../page-components/WhoWeAre'

interface Props {
  data: PageQueryData
}

const WhoWeArePage: React.FC<Props> = ({ data }) => (
  <WhoWeAre
    pageContext={{
      ...processContext(data),
      contactLinkOptions: { element: ContactElement.ContactSection },
    }}
  />
)

export const query = graphql`
  query {
    page: allContentfulPage(filter: {slug: {eq: "who-we-are"}}) {
      edges {
        node {
          ... PageFragment
        }
      }
    }
  }`

export default WhoWeArePage
